import { component } from 'picoapp'

export default component((node, ctx) => {
  const images = document.querySelectorAll('.product-images .image[data-variant]');
  const swatches = node.querySelectorAll('input[data-image]');
  const headerHeight = document.querySelector('.slater-header').offsetHeight + 25;

  for (let i = 0; i < swatches.length; i++) {
    const swatch = swatches[i];

    swatch.addEventListener('click', function() {
      // scroll to the corresponding image
      const swatchLink = swatch.dataset.image;
      // console.log(swatchLink)

      for (let i = 0; i < images.length; i++) {
        const img = images[i];

        if (swatchLink == img.dataset.variant) {
          const y = img.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      }
    })
  }
})